import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appRequestStepAnchor]'
})
export class RequestStepAnchorDirective {
  public readonly viewContainerRef = inject(ViewContainerRef);
}
